import { Form } from "antd";
import type { FormInstance } from "antd/es/form/Form";
import i18n from "i18next";
import { type FC } from "react";

import type { DataGroupEntity } from "src/app/features/DataGroup/types/DataGroupEntity";
import { DrawerForm } from "../../../../../components/DrawerForm/DrawerForm";
import { TextInput } from "../../../../../components/Form/formComponents";
import type { SearchFormProps } from "../../../../../components/Form/types/types";

type DataGroupSearchTerminalFormProps = SearchFormProps<DataGroupEntity> & { form?: FormInstance; onReset?: () => void };

export const DataGroupSearchTerminalForm: FC<DataGroupSearchTerminalFormProps> = ({ searchCallback, onReset, form }) => {
    return (
        <DrawerForm onSubmit={searchCallback} onReset={onReset} form={form}>
            <Form.Item name="terminalId" label={i18n.t("list.searchTerminal.dialog.terminalId")}>
                <TextInput name="terminalId" />
            </Form.Item>

            <Form.Item label={i18n.t("list.searchTerminal.dialog.serialNumber")} name="serialNumber">
                <TextInput name="serialNumber" />
            </Form.Item>
        </DrawerForm>
    );
};
